import { PlusOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import cn from 'classnames';

import { useSubscriptionsPageHeader } from '../hooks/useSubscriptionsPageHeader';

import type { FC } from 'react';

export const SubscriptionsPageHeader: FC = () => {
  const { canCreate, isMobile, openCreateModal } = useSubscriptionsPageHeader();

  if (!canCreate) {
    return null;
  }

  // Space центрирует кнопку по высоте шапки, как в других headerContent
  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      className={cn({ 'full-width': isMobile })}
    >
      <Button
        type="primary"
        icon={<PlusOutlined />}
        className={cn({ 'full-width': isMobile })}
        onClick={openCreateModal}
        data-testid="add-subscription"
      >
        Добавить абонемент
      </Button>
    </Space>
  );
};
